import { Button, Popconfirm, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import { currencyFormat } from "../../../utils/helpers/currency";

export interface DataType {
  id: number;
  name: string;
  price: number;
  company: number;
  companiesPricesBetweenRegions?: CompaniesPricesBetweenRegions[];
  currencyId?: number | null;
}

export interface CurrencyMap {
  [key: number]: string;
}

export interface CompaniesPricesBetweenRegions {
  id: number;
  companyId: number;
}

export const columns = (
  handleClick: (price: any) => void,
  handleDelete: (id: number) => Promise<void>,
  companyMap: Map<number, string>,
  currencyMap?: CurrencyMap,
): ColumnsType<DataType> => [
    {
      title: "ID",
      dataIndex: "id",
      sorter: false,
      width: "200px",
    },
    {
      title: "Región A",
      sorter: false,
      width: "200px",
      dataIndex: "origin",
      render: (origin) => origin.name,
    },
    {
      title: "Región B",
      sorter: false,
      width: "200px",
      dataIndex: "destination",
      render: (destination) => destination.name,
    },
    {
      title: "Precio",
      sorter: false,
      width: "200px",
      dataIndex: "price",
      render: (price) => currencyFormat(+price),
    },
    {
      title: "Precio conductor",
      sorter: false,
      width: "200px",
      dataIndex: "driverPrice",
      render: (price) => currencyFormat(+price),
    },
    {
      title: "Empresas",
      sorter: false,
      width: "200px",
      render: (_, record) => {
        if (!!record.companiesPricesBetweenRegions?.length)
          return record.companiesPricesBetweenRegions
            ?.map((x) => companyMap.get(x.companyId) || x.companyId)
            .join(", ");

        return companyMap.get(record.company) || record.company;
      },
    },
    {
      title: "Prioridad",
      dataIndex: "priority",
      sorter: false,
      width: "100px",
    },
    {
      title: "Moneda",
      dataIndex: "currencyId",
      sorter: false,
      width: "120px",
      render: (currencyId) => (currencyId && currencyMap ? currencyMap[currencyId] || currencyId : "-"),
    },
    {
      title: "Acciones",
      key: "action",
      width: "300px",
      render: (_, record) => (
        <Space size="middle">
          <Button onClick={() => handleClick(record)}>
            <Space>Editar Precios</Space>
          </Button>
          <Popconfirm
            title="Estás seguro de eliminar este precio?"
            onConfirm={() => handleDelete(record.id)}
            okText="Si"
            cancelText="No"
          >
            <Button danger>Eliminar</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];
